import angular from 'angular';

/**
 * @param {TransitionService} $transitions
 * @param {$document} $document
 * @returns {Object}
 */
export function pageLoader($transitions, $document) {

    return {
        link: (scope, element, attrs) => {

            const body = $document.find('body');

            body.addClass('page-on-load');

            const spinnerBar = angular.element(require('../templates/spinner-bar.template.html'));

            body.append(spinnerBar);

            const deregister = $transitions.onSuccess({}, (transition) => {

                spinnerBar.remove();
                body.removeClass('page-on-load');
                deregister();
            });
        }
    };
}

pageLoader.$inject = [ '$transitions', '$document' ];


// WEBPACK FOOTER //
// ./src/ui/directives/page-loader.directive.js